export type RoleLabel = 'Administrador' | 'Profissional' | 'Recepcionista';

export type Permissions = {
  agenda: boolean;
  patients: boolean;
  finance: boolean;
  teleconsultation: boolean;
  repository: boolean;
  subscriptions: boolean;
  supervisorChat: boolean;
  settings: boolean;
};

/**
 * Permissões padrão por papel, conforme o roteiro do produto:
 *
 * - Administrador: acesso a tudo.
 * - Profissional: tudo, exceto perfis de usuário (que já é restrito ao admin);
 *   enxerga apenas os próprios pacientes e a própria agenda. Em Configurações
 *   edita só a própria identidade (a clínica fica somente leitura) e não vê a
 *   Zona de Perigo.
 * - Recepcionista: painel, pacientes (somente o cadastro — prontuário, gestão
 *   de ciclos e arquivos ficam bloqueados dentro da ficha), supervisor chat,
 *   agenda e sua configuração, financeiro, teleconsulta, repositório,
 *   assinatura e configurações. Nunca perfis de usuário.
 */
export function permissionsForRole(role: string): Permissions {
  if (role === 'Administrador') {
    return {
      agenda: true,
      patients: true,
      finance: true,
      teleconsultation: true,
      repository: true,
      subscriptions: true,
      supervisorChat: true,
      settings: true,
    };
  }

  if (role === 'Recepcionista') {
    return {
      agenda: true,
      patients: true,
      finance: true,
      teleconsultation: true,
      repository: true,
      subscriptions: true,
      supervisorChat: true,
      settings: true,
    };
  }

  // Profissional (padrão). Financeiro: só os próprios lançamentos (bloco #66).
  return {
    agenda: true,
    patients: true,
    finance: true,
    teleconsultation: true,
    repository: true,
    subscriptions: false,
    supervisorChat: true,
    settings: true,
  };
}

/** Só o administrador edita a identidade da clínica e vê a Zona de Perigo. */
export function canEditClinicIdentity(role?: string): boolean {
  return role === 'Administrador';
}

/**
 * Bloco #45/#40: o WhatsApp de "Contato e Localização" é editado pelo
 * administrador (número da clínica) e por cada recepcionista (o número em que
 * ela recebe os avisos da recepção).
 */
export function canEditContactWhatsapp(role?: string): boolean {
  return role === 'Administrador' || role === 'Recepcionista';
}

/** A página pública de agendamento é da clínica: administrador e recepção. */
export function canManageBookingPage(role?: string): boolean {
  return role === 'Administrador' || role === 'Recepcionista';
}

/** Somente o administrador gerencia perfis de usuário. */
export function canManageUserProfiles(role?: string): boolean {
  return role === 'Administrador';
}
